module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('strong', [_vm._v("IT’S A BLESSIN’ TO BLOW A HUNDRED THOU’ IN A RECESSION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG: "), _c('strong', [_vm._v("“KINDA LIKE A BIG DEAL”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("TIL THE CASKET DROPS")]), _vm._v(" BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("CLIPSE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One must believe God is looking favorably upon oneself to be able to frivolously spend $100,000 without worrying about how their bank account balance will be affected during a time when most of the population is struggling financially due to an economic crisis.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('strong', [_vm._v("USED TO MAKE A THOUSAND DOLLARS EVERY TIME I PLAYED HOOKY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG: "), _c('strong', [_vm._v("“FEEL ME”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("THA CARTER II")]), _vm._v(" BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("LIL WAYNE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is possible that while skipping school, rather than going to the mall, watching a movie, or socializing with friends, one could be engaging in lucrative activities, such as drug dealing, that might yield amounts of money much greater than the average student’s allowance or summer job.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("GRINDIN’ DAILY TO STACK MY BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG: "), _c('strong', [_vm._v("“THEY DON’T KNOW”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("THE PEOPLES CHAMP")]), _vm._v(" BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("PAUL WALL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I work hard every day, earning income by doing whatever I have to do to get by. As a result of my effort, I am able to pile up the money I make as if it were slices of food made by mixing water with ground flour.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e9393bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01ch05.vue
// module id = 93
// module chunks = 0